(ns practitest.frontend.vsadmin
  (:require
    [reagent.dom :as rdom]
    [re-frame.core :as re-frame]
    [ajax.core :as ajax]
    [practitest.frontend.vsadmin.events :as events]
    [practitest.frontend.vsadmin.views :as views]))

(defn ^:dev/after-load mount-root []
  (when-let [str-el (.getElementById js/document "vsadmin")]
    (rdom/unmount-component-at-node str-el)
    (rdom/render [views/main-panel] str-el)))

(defn ^:export init [options]
  (when-let [csrf-token (some-> js/document
                                (.querySelector "meta[name='csrf-token']")
                                (.getAttribute "content"))]
    (let [csrf-interceptor (ajax/to-interceptor
                            {:name    "CSRF Interceptor"
                             :request #(assoc-in % [:headers "X-CSRF-Token"] csrf-token)})]
      (swap! ajax/default-interceptors (partial cons csrf-interceptor))))

  (re-frame/dispatch-sync
   [::events/initialize-db (js->clj options :keywordize-keys true)])
  (mount-root))
